// extracted by mini-css-extract-plugin
export default {"productCard":"ProductCard_partner_productCard__pGT9O"};